// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.matchListHeader {
  padding: 1rem 1rem 0.5rem;
  padding-top: 4rem;
  text-align: center;
  color: var(--text-primary);
  background-color: var(--background);
}

.match-list-container {
  height: 100%;
  background-color: var(--background);
}

.scroll-container {
  min-height: calc(100vh - 80px);
  max-height: calc(100vh - 80px);
  overflow: auto;
  overscroll-behavior: none;
  -webkit-overflow-scrolling: touch;
  padding: 1rem 0.5rem 3.2rem;
  background-color: var(--background);
}

.card-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
  padding: 0.5rem;
}

.matchCard {
  background-color: var(--background-consistent);
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
  transition: all 0.2s ease-in-out;
  aspect-ratio: 3/4;
  overflow: hidden;
}

.match-card-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0.75rem;
}

.matchCard:hover {
  transform: scale(1.02);
}

.matchCard:active {
  transform: scale(0.98);
}

.match-card-image {
  width: 70%;
  aspect-ratio: 1;
  border-radius: 50%;
  margin: 1rem auto;
  display: block;
  box-shadow: 0 2px 4px rgb(0 0 0 / 0.1);
  border: 1px solid var(--theme-consistent);
  object-fit: cover;
  object-position: center;
}

.cardInfo {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 0.75rem;
  text-align: center;
}

/* .card-name {
  text-align: center;
  color: var(--text-consistent);
} */

.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  padding: 0 0.25rem;
}

.card-firstname {
  font-weight: 600;
  font-size: 2rem;
  line-height: 1.25rem;
  margin-bottom: 0.25rem;
}

.card-lastname {
  font-size: 1.75rem;
  line-height: 1.5rem;
}

.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 80px);
  background-color: var(--background);
}

.card-matches-message {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
  padding: 16px 16px 8px;
  text-align: center;
  color: var(--text-primary);
  background-color: var(--background);
}

/* Small mobile devices */
@media screen and (max-width: 320px) {
  .card-container {
    gap: 0.5rem;
    padding: 0.25rem;
  }

  .match-card-content {
    padding: 0.5rem;
  }

  .match-card-image {
    width: 60%;
  }

  .card-firstname {
    font-size: 1.25rem;
  }

  .card-lastname {
    font-size: 0.90rem;
  }
}

/* Larger mobile devices */
@media screen and (min-width: 375px) {
  .card-firstname {
    font-size: 1.5rem;
  }

  .card-lastname {
    font-size: 1rem;
  }
}

/* Tablet and larger */
@media screen and (min-width: 768px) {
  .card-container {
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
    padding: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/MatchList.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,cAAc;EACd,yBAAyB;EACzB,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,8CAA8C;EAC9C,qBAAqB;EACrB,2CAA2C;EAC3C,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,sCAAsC;EACtC,yCAAyC;EACzC,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;;GAGG;;AAEH;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA,yBAAyB;AACzB;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,qCAAqC;IACrC,SAAS;IACT,aAAa;EACf;AACF","sourcesContent":[".matchListHeader {\n  padding: 1rem 1rem 0.5rem;\n  padding-top: 4rem;\n  text-align: center;\n  color: var(--text-primary);\n  background-color: var(--background);\n}\n\n.match-list-container {\n  height: 100%;\n  background-color: var(--background);\n}\n\n.scroll-container {\n  min-height: calc(100vh - 80px);\n  max-height: calc(100vh - 80px);\n  overflow: auto;\n  overscroll-behavior: none;\n  -webkit-overflow-scrolling: touch;\n  padding: 1rem 0.5rem 3.2rem;\n  background-color: var(--background);\n}\n\n.card-container {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 0.75rem;\n  padding: 0.5rem;\n}\n\n.matchCard {\n  background-color: var(--background-consistent);\n  border-radius: 0.5rem;\n  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);\n  transition: all 0.2s ease-in-out;\n  aspect-ratio: 3/4;\n  overflow: hidden;\n}\n\n.match-card-content {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 0.75rem;\n}\n\n.matchCard:hover {\n  transform: scale(1.02);\n}\n\n.matchCard:active {\n  transform: scale(0.98);\n}\n\n.match-card-image {\n  width: 70%;\n  aspect-ratio: 1;\n  border-radius: 50%;\n  margin: 1rem auto;\n  display: block;\n  box-shadow: 0 2px 4px rgb(0 0 0 / 0.1);\n  border: 1px solid var(--theme-consistent);\n  object-fit: cover;\n  object-position: center;\n}\n\n.cardInfo {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding-top: 0.75rem;\n  text-align: center;\n}\n\n/* .card-name {\n  text-align: center;\n  color: var(--text-consistent);\n} */\n\n.text-ellipsis {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100%;\n  padding: 0 0.25rem;\n}\n\n.card-firstname {\n  font-weight: 600;\n  font-size: 2rem;\n  line-height: 1.25rem;\n  margin-bottom: 0.25rem;\n}\n\n.card-lastname {\n  font-size: 1.75rem;\n  line-height: 1.5rem;\n}\n\n.loader-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: calc(100vh - 80px);\n  background-color: var(--background);\n}\n\n.card-matches-message {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 80vh;\n  padding: 16px 16px 8px;\n  text-align: center;\n  color: var(--text-primary);\n  background-color: var(--background);\n}\n\n/* Small mobile devices */\n@media screen and (max-width: 320px) {\n  .card-container {\n    gap: 0.5rem;\n    padding: 0.25rem;\n  }\n\n  .match-card-content {\n    padding: 0.5rem;\n  }\n\n  .match-card-image {\n    width: 60%;\n  }\n\n  .card-firstname {\n    font-size: 1.25rem;\n  }\n\n  .card-lastname {\n    font-size: 0.90rem;\n  }\n}\n\n/* Larger mobile devices */\n@media screen and (min-width: 375px) {\n  .card-firstname {\n    font-size: 1.5rem;\n  }\n\n  .card-lastname {\n    font-size: 1rem;\n  }\n}\n\n/* Tablet and larger */\n@media screen and (min-width: 768px) {\n  .card-container {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 1rem;\n    padding: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
